import { InstallationRequestStatus } from 'common/types/kraken-core/Installation'

export const INSTALLATION_REQUEST_STORAGE_PREFIX = 'integration-module:installation-request:'

export const INSTALLATION_REQUEST_MAX_AGE_MS = 45 * 60 * 1000

export interface StoredInstallationRequest {
  id: string
  subject_id: string
  status: InstallationRequestStatus
  channel: string
  created_at: string
}

function storageKey(subjectId: string): string {
  return `${INSTALLATION_REQUEST_STORAGE_PREFIX}${subjectId}`
}

export function getStoredInstallationRequest(subjectId: string): StoredInstallationRequest | null {
  try {
    const raw = localStorage.getItem(storageKey(subjectId))
    if (!raw) return null
    return JSON.parse(raw) as StoredInstallationRequest
  } catch {
    return null
  }
}

export function setStoredInstallationRequest(request: StoredInstallationRequest): void {
  localStorage.setItem(storageKey(request.subject_id), JSON.stringify(request))
}

export function removeStoredInstallationRequest(subjectId: string): void {
  localStorage.removeItem(storageKey(subjectId))
}

export function isInstallationRequestExpired(
  request: Pick<StoredInstallationRequest, 'created_at'>,
  now: number = Date.now()
): boolean {
  const createdAt = new Date(request.created_at).getTime()
  if (Number.isNaN(createdAt)) return true
  return now - createdAt > INSTALLATION_REQUEST_MAX_AGE_MS
}
